import React from 'react';
import { useSelector } from 'react-redux';
import Result from '../../components/Result';
import ResultCount from '../../components/ResultCount';
import styles from './SearchResultsContainer.module.scss';
import utdanningerIcon from '../../img/Ikoner_Utdanning_large.svg';
import laerestederIcon from '../../img/Ikoner_Læresteder_large.svg';
import artikkelIcon from '../../img/Ikoner_Artikkel-intervju_large.svg';
import yrkerIcon from '../../img/Ikoner_Yrker_large.svg';
import annetIcon from '../../img/Ikoner_Oppgaver-utdanningsvalg_large.svg';
import { getUtdanningSiteBaseUrl } from '../../Utils/getUtdanningSiteBaseUrl';
import kiIcon from '../../img/Ikoner_Ki-Sok_small.svg';
const SearchResultsContainer = (props) => {
  const newFilterState = useSelector((state) => state.newFilterReducer);
  const searchResults = newFilterState.searchResults;
  const totalItems = newFilterState.totalItems;

  const baseUrl = getUtdanningSiteBaseUrl();
  const MAX_TEXT_LENGTH = 350;
  const DOTS = '...';

  // Get possible error related to the results.
  let errorElement = null;
  const errors = newFilterState.errors;
  if (errors.results !== undefined) {
    const error = errors.results.response.error;
    const msg = error.message;
    errorElement = (
      <div className={styles.error}>
        Forespørsel feil: <span>{msg}</span>
      </div>
    );
  }

  // If there are no results, skip everything else.
  if (!searchResults.length && !newFilterState.loading) {
    return (
      <>
        {errorElement}
        <div className={styles.noresults} id="main-content">
          Ingen treff
        </div>
      </>
    );
  }

  const searchResultsR = searchResults.map((data) => {
    let type;
    let typecolor = null;
    let org;
    let niva = null;
    if (
      data.entity_type_id === 'organisasjon' ||
      data.entity_type_id === 'dk_org'
    ) {
      niva = data.type;
      type = 'Lærested';
      if (Array.isArray(data.organisasjon)) {
        org = data.organisasjon[0];
      } else {
        org = data.organisasjon;
      }
    } else if (
      data.entity_type_id.includes('_tilbud') ||
      data.entity_type_id.includes('dk_')
    ) {
      niva = data.type;
      type = 'Utdanning';
      if (
        data.entity_type_id.includes('fagskole') ||
        data.entity_type_id === 'dk_fs'
      ) {
        typecolor = 'fag';
      }
      if (
        data.entity_type_id.includes('folkehogskole') ||
        data.entity_type_id === 'dk_fhs'
      ) {
        typecolor = 'fhs';
      }
      if (
        data.entity_type_id.includes('uh') ||
        data.entity_type_id === 'dk_uk'
      ) {
        typecolor = 'uh';
      }
      if (
        data.entity_type_id.includes('vgs' || data.entity_type_id === 'dk_vgs')
      ) {
        typecolor = 'vgs';
      }
    } else if (data.type === 'Utdanningsoversikt') {
      type = 'Utdanningsoversikt';
      if (Array.isArray(data.utdanningsniva)) {
        org = data.utdanningsniva[0];
      } else {
        org = data.utdanningsniva;
      }
      niva = org;
    } else {
      type = data.type;
      typecolor = null;
    }
    if (type === 'verktoy') {
      type = 'verktøy';
    }
    /*
            @see https://kompetansenorge.atlassian.net/browse/UTDTEK-724?focusedCommentId=78311
            Videregående → Videregående
            Fagskole → Fagskole
            Universitet og høgskole → Universitet og høgskole
            Frilynt folkehøgskole og Kristen folkehøgskole → Folkehøgskole
            Resten → Annen utdanning
        */
    switch (org) {
      case 'Videregående':
        typecolor = 'vgs';
        break;
      case 'Fagskole':
        typecolor = 'fag';
        break;
      case 'Universitet og høgskole':
        typecolor = 'uh';
        break;
      case 'Frilynt folkehøgskole':
      case 'Kristen folkehøgskole':
        typecolor = 'fhs';
        break;
      default:
        console.log('Missing education entity in switch');
    }

    let myUrl = data.url;
    if (!myUrl.startsWith('http')) {
      myUrl = baseUrl + data.url;
    }

    let image = null;
    if (data.image_url && data.image_url.length > 0) {
      image = {};
      image['url'] = data.image_url;
      image['title'] = data.image_title;
      image['alt'] = data.image_alt;
    }

    if (data.description.length > MAX_TEXT_LENGTH) {
      data.description = data.description.substr(
        0,
        MAX_TEXT_LENGTH - DOTS.length,
      );
      data.description += DOTS;
    }
    let icon = null;
    switch (type) {
      case 'Utdanning':
      case 'Utdanningsoversikt':
        icon = utdanningerIcon;
        break;
      case 'Lærested':
        icon = laerestederIcon;
        break;
      case 'artikkel':
      case 'intervju':
      case 'Artikkel':
        icon = artikkelIcon;
        break;
      case 'yrke':
      case 'Yrke':
        icon = yrkerIcon;
        break;
      case 'verktoy':
      case 'Verktøy':
        icon = annetIcon;
        break;
      default:
        break;
    }

    // Capitalize first letter.
    type = type.charAt(0).toUpperCase() + type.slice(1);
    return (
      <Result
        title={data.title}
        url={myUrl}
        icon={icon}
        typeColor={typecolor}
        image={image ? image : null}
        type={type}
        text={data.description}
        niva={niva}
        larested={data.larested}
        stedsnavn={data.stedsnavn}
        entity_type_id={data.entity_type_id}
        isClickable={true}
      />
    );
  });

  const param = new URLSearchParams(window.location.hash.slice(1));
  const isKiSearch = param.get('type') === '"ki"';

  return (
    <div className={styles.wrapper} id="main-content">
      {isKiSearch && (
        <Result
          title="Vi viser ikke resultater ennå."
          type="Ny tjeneste under utvikling"
          text="Spørsmålet ditt er notert, og det bestemmer hva vi bygger videre. Takk for hjelpen!"
          isClickable={false}
          icon={kiIcon}
        />
      )}

      {newFilterState.loading && <div className={styles.loading}>Laster</div>}

      {errorElement}
      {!newFilterState.isMobile && <ResultCount count={totalItems} />}
      {searchResultsR}
    </div>
  );
};

export default SearchResultsContainer;
